export default __webpack_public_path__ + "static/FAQ-127337e4c3a84cccfbaf1e0fc8c1438d.png";